import { getPagination } from '@/utils';

function queryNumber(iri, key) {
  if (typeof iri !== 'string') return null;
  const queryIndex = iri.indexOf('?');
  if (queryIndex === -1) return null;

  const value = new URLSearchParams(iri.slice(queryIndex + 1)).get(key);
  if (value == null || value === '') return null;

  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
}

/**
 * Maps an API Platform Hydra collection to the pagination object
 * consumed by TableSticky / TablePagination.
 *
 * Expected source fields: hydra:totalItems, hydra:view (@id, hydra:first,
 * hydra:last, hydra:next). Page and page size are read from those IRIs
 * (`page`, `itemsPerPage`).
 */
export function adaptHydraPagination(collection, fallback = {}) {
  const members = Array.isArray(collection?.['hydra:member'])
    ? collection['hydra:member']
    : [];
  const view = collection?.['hydra:view'] || {};
  const totalFromPayload = Number(collection?.['hydra:totalItems']);
  const totalCount = Number.isFinite(totalFromPayload) ? totalFromPayload : members.length;

  const fallbackItemsPerPage = Number(fallback.itemsPerPage);
  const itemsPerPage =
    queryNumber(view['@id'], 'itemsPerPage') ||
    queryNumber(view['hydra:first'], 'itemsPerPage') ||
    queryNumber(view['hydra:last'], 'itemsPerPage') ||
    (fallbackItemsPerPage > 0 ? fallbackItemsPerPage : null) ||
    members.length ||
    10;

  const fallbackPage = Number(fallback.page);
  const current =
    queryNumber(view['@id'], 'page') ||
    (fallbackPage > 0 ? fallbackPage : null) ||
    queryNumber(view['hydra:first'], 'page') ||
    1;

  const pagination = getPagination(totalCount, current, itemsPerPage);

  const first = queryNumber(view['hydra:first'], 'page');
  const last = queryNumber(view['hydra:last'], 'page');
  if (first) pagination.first = first;
  if (last) {
    pagination.last = last;
    pagination.pageCount = last;
  }

  if (Object.prototype.hasOwnProperty.call(view, 'hydra:next')) {
    pagination.next = queryNumber(view['hydra:next'], 'page');
  } else if (view['@id']) {
    pagination.next = null;
  }

  if (totalCount === 0) {
    pagination.current = 1;
    pagination.first = 1;
    pagination.last = 1;
    pagination.pageCount = 1;
    pagination.next = null;
    pagination.currentItemCount = 0;
    pagination.firstItemNumber = 0;
    pagination.lastItemNumber = 0;
  }

  return pagination;
}
